// src/plugins/appInsights.js
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const appInsights = new ApplicationInsights({
  config: {
    connectionString: "InstrumentationKey=80f752e2-d17b-4acc-a5f0-80f4d1b7a37d",
    enableAutoRouteTracking: true
  }
});
appInsights.loadAppInsights();

export default appInsights;
